// extracted by mini-css-extract-plugin
export default {"related":"RelatedProducts_related__JXuAH","item":"RelatedProducts_item__kUYPP","title":"RelatedProducts_title__LXCKZ"};